/**
 * AuthService.js
 * Handles authentication state management and prevents race conditions
 */

// This will be our auth state promise that resolves when auth is ready
let authReadyPromise = null;
let authReadyResolver = null;

// Initialize the promise
const initAuthPromise = () => {
  if (!authReadyPromise) {
    authReadyPromise = new Promise(resolve => {
      authReadyResolver = resolve;
    });
  }
  return authReadyPromise;
};

// Call this when auth is complete (with user data or null for logged out)
const setAuthReady = (userData) => {
  if (!authReadyResolver) {
    initAuthPromise();
  }
  authReadyResolver(userData);
};

// Reset auth state (for logout)
const resetAuthState = () => {
  authReadyPromise = null;
  authReadyResolver = null;
  initAuthPromise();
};

// Wait for auth to be ready before proceeding
const waitForAuth = async () => {
  if (!authReadyPromise) {
    initAuthPromise();
  }
  return authReadyPromise;
};

// Check if a userId is valid
const isValidUserId = (userId) => {
  return userId && userId !== 'undefined' && userId !== undefined;
};

export default {
  initAuthPromise,
  setAuthReady,
  resetAuthState,
  waitForAuth,
  isValidUserId
};
